/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformServer, ViewportScroller } from '@angular/common';
import { AppService } from '../api.service';
import {fade, fadeInOut,fadeimagesInOut,slideInOut,slideHomeInOut,animSlider, activeSlide,slide1InOut} from'../animations';
import { isPlatformBrowser } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { DepartmentsService } from '../services/departments.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { OwlService } from '../services/owl.service';
import { HomeService } from '../home.service';
import { ProjectsService } from '../services/project.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CashbackService } from '../services/cashback.service';
import { AbInfoPopupService } from '../services/ab-info-popup.service';
import { WindowService } from '../services/window.service';
import { interval, Subscription,} from "rxjs";
import { LocalStorageService } from '../services/localstorage.service';
import { CachingService } from '../services/caching.service';
import { RatingService } from '../services/rating.service';
import { IntersectionObserverService } from '../services/intersection-observer.service';
@Component({
  selector: 'app-v3-home',
  templateUrl: './v3-home.component.html',
  styleUrls: ['./v3-home.component.scss'],
  animations:[fade, fadeInOut,fadeimagesInOut,slideInOut,slideHomeInOut,animSlider,activeSlide,slide1InOut],  
})
export class V3HomeComponent implements AfterViewInit, OnInit, OnDestroy{
  trigger$: any;
  active_categorys:any[]=[];
  dealer_citys:any[]=[];
  visibleSidebarCore=false;
  active_option:string | undefined;
  activeCoreSubCategory: boolean | undefined;
  activermainoptionsindex: any;
  activeprofTypeindex: any;
  active_pros_option: string | undefined;
  is_load_type: boolean | undefined;
  pro_types: any[]=[];
  proClickCount=0;
  isCoreOption=false;
  category_brand_list: any[]=[];
  category_brand_load: boolean | undefined;
  global_loader=false;
  page_date_load: boolean | undefined;
  mostsearchproducts: any[] = [];
  activeMostCatId: number | undefined;
  is_more_product_loader: boolean | undefined;
  activeClassCatId = 7;
  isProductEconomical: any = true;
  isProductStandard: any = true;
  isProductPremium: any = true;
  isProductLuxury: any = true;
  is_most_economical: any = false;
  is_standard_choice: any = false;
  is_premium_product: any = false;
  is_luxury_product: any = false;
  class_wise_products: any[]=[];
  departments_list: any[]=[];
  is_product_class_loader: boolean | undefined;
  // background_color=['#EAFAEE','#EAF1FA','#EEEAFA','#F9EAFA','#FAEAF1']
  background_color=['#97A2C2']
  brand_list: any;
  is_brand_loader: boolean | undefined;
  activemaincategoryDealer: number | undefined;
  top_dealers: any[] | undefined;
  is_dealers_loader: boolean | undefined;
  minval = 100;
  maxval = 1000;
  budgetBtnText: string | undefined;
  budgetTitle: string | undefined;
  hometypes: any[]=[];
  pageLoad: boolean | undefined;
  citys: any;
  infoForm!: FormGroup;
  submitted: boolean | undefined;
  isAreaNull: boolean | undefined;
  inline_loader: boolean | undefined;
  activeCityi: any;
  project_loader: boolean | undefined;
  project_id: any;
  isAssignedBudget: boolean | undefined;
  work_list: any[]=[];
  totalBudget: any;
  is_budget_cal_loader: boolean | undefined;
  is_professionloader:boolean | undefined;
  profession_list: any;
  isOnMobilePlatform: any;
  displayedProfession_list: any[]=[];
  isBrowser = false;
  newlaunchedproducts: any[]=[];
  is_new_launched_loader: boolean | undefined;
  isUrlDisplayBudget: any;
  isProCityLoading: boolean | undefined;
  selected_Type: any;
  prof_locations: any[]=[];
  category_prof_brand_load: boolean | undefined;
  total_brand: any;
  saveidea_brands: any[]=[];
  howitworksptes: any[] = [];
  recentlyViewedProducts: any[] = [];
  slug_name = '';
  activeStepindex = 0;
  stepSubscription: Subscription | undefined;
  showCross: boolean | undefined;
  positionBudget= 'center';
  sId: any;
  newproPage=0;
  active_budget_index:number | undefined;
  is_more_types:false | undefined;
  showButton = false;
  product_type_list: any;
  is_showmore: any;
  showAllProducts=false;
  homepage_offercard:any[]=[];
  Individual_brand:any[]=[];
  public _is_hero_list =false;
  items: any[]=[];
  @ViewChild('owlCarousel', { static: false }) owlCarousel!: ElementRef;

  hero_banner_list:any[]=[];
  // mobile_hero_banner_list:[]=[];
  state = 'in';
  direction = '100';
  isServer= false;
  state1: any;
  animationState = 0;
  // is_pageup_button: boolean =false;
  is_pageup_button!: boolean;
  productSampQueryParm: any;
  productSampUrl: string;
  @ViewChild('videoPlayer') video!: ElementRef<HTMLVideoElement>;

  // private ccService:NgcCookieConsentService
  // private ssrCookieService:SsrCookieService,
constructor(private window: WindowService, private _actRouter: ActivatedRoute,public title: Title, public meta: Meta,public _as:AppService, private ViewportScroller: ViewportScroller,public _ds: DepartmentsService,public _router:Router, private intersectionObserver: IntersectionObserverService,
  public _owlservice: OwlService, @Inject(PLATFORM_ID) private platformId: any,public _homeservice: HomeService,private localStorageService: LocalStorageService,private elementRef: ElementRef,public router: Router,
  public _project: ProjectsService, private _fb: FormBuilder,public _cashback:CashbackService,public _abpopupinfo:AbInfoPopupService,private cdref: ChangeDetectorRef,private cachingService: CachingService, private rating_service:RatingService){
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);
    // if(isPlatformBrowser(platformId)){
  this.isOnMobilePlatform = this._as.isOnMobilePlatform;
  this.howitworksptes = this._homeservice.howitworksteps;
  
  if(_as.isProduction){
    this.homepage_offercard=[
      {id:1,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Veneer_xyij9x.png',title:'Veneers',link:"product/woodwork",queryparams:{subCat:26,page:1}},
      {id:2,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Panels_z7drvo.png',title:'Panels',link:"product/woodwork",queryparams:{subCat:204,page:1,category:333}},
      {id:3,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Boards_dybvod.png',title:'Boards',link:"/product/woodwork",queryparams:{subCat:23,page:1,category:300}},
      {id:4,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Floor_tiles_r0buux.png',title:'Floor Tiles',link:"product/tiles-flooring",queryparams:{subCat:1,page:1}},
      {id:5,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Glass_Panels_yldq4x.png',title:'Glass Panels',link:"product/panels-louvers",queryparams:{subCat:204,page:1,category:338,}},
      {id:6,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Laminates_t5fjap.png',title:' Laminates',link:"product/panels-louvers",queryparams:{subCat:25,page:1}},
      {id:7,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Banding_Tape_hdwsfz.png',title:'Banding Tape',link:"/product/woodwork",queryparams:{subCat:208,page:1,}},
      {id:8,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Louvers_xujpy9.png',title:' Louvers ',link:"product/panels-louvers",queryparams:{subCat:205,page:1}},
      {id:9,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Plyboards_hhwagc.png',title:'Plyboards',link:"/product/woodwork",queryparams:{subCat:175,page:1}},
      {id:10,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Wall_Tiles_rk0thi.png',title:'Wall Tiles',link:"product/tiles-flooring",queryparams:{subCat:61,page:1}},
      {id:11,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Blinds_ic8wyh.png',title:'Blinds',link:"product/furnishing",queryparams:{subCat:203,page:1}},
     
    ];

    this.Individual_brand=[
      {id:1,brand:'Franke',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/7_f4elmb.png',title:'Premium Kitchen Sinks',sub_title:'Efficient, durable & stylish products',altText:'Premium Kitchen Sinks',link:"./brand/Franke",},
      {id:2,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/haier_ccf28z.webp',title:'',sub_title:'',altText:'Would No.1 Brand inMajor appliances haier',link:"./brand/haier",},
      {id:3,brand:'Nippon Paint',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/2_ffltn3.png',title:'Bringing Color to Life',sub_title:'Vibrant, durable, premium-quality paints.',altText:"Bringing Color to Life",link:"./brand/nippon",},
      {id:4,brand:'RAK',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/8_udel3u.png',title:'Tiles and Sanitary Solution',sub_title:'Elegant, hygienic and customer-focused products',altText:"Tiles and Sanitary Solution",link:"./brand/rak-ceramics-india-pvt-ltd",},
      {id:5,brand:'HAFELE',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/14_lo2bte.png',title:'Smart Home Appliances',sub_title:'Stylish, Efficient, innovative, user-friendly solutions',altText:"Smart Home Appliances",link:"./brand/hafele-india-hardware",},
      {id:6,brand:'Philips',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/11_xzplax.png',title:'Advanced Lighting Solutions',sub_title:'Sleek and modern lighting for homes',altText:"Advanced Lighting Solutions",link:"./brand/philips",},
      {id:7,brand:'Cera',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/12_l6jfr6.png',title:'Modernize Your Home with Cera',sub_title:'Efficient, stylish, hygienic solutions',altText:"Modernize Your Home with Cera",link:"./brand/cera",},
      {id:8,brand:'Hagar',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/1_j4vgio.png',title:'Redefine Your Bathroom Elegance',sub_title:'Stylish, durable, innovative bath fittings.',altText:"'Redefine Your Bathroom Elegance",link:"./brand/hagar",},
      {id:9,brand:'Million',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/4_qq7k3u.png',title:'Switch On to Elegance',sub_title:'Sleek, durable, high-performance switches.',altText:"Switch On to Elegance",link:"./brand/million",},
      {id:10,brand:'Atomberg',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/5_uuaz2z.png',title:'Cool Comfort, Stylish Design',sub_title:'Sleek, silent, and powerful fans for your spaces.',altText:"Cool Comfort, Stylish Design",link:"/brand/atomberg",},
      {id:11,brand:'FABER',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/3_zf5ji2.png',title:'Enhance Everyday Living',sub_title:'Efficient, stylish, innovative home appliances.',altText:"Enhance Everyday Living",link:"./brand/faber",},
  
    ]
    this.productSampUrl= "product/woodwork";
    this.productSampQueryParm= {subCat:23,page:1,isSamplechecked:true};
  }else{
    this.homepage_offercard=[
      {id:1,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Veneer_xyij9x.png',title:'Veneers',link:"product/woodwork",queryparams:{subCat:26,page:1}},
      {id:2,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Panels_z7drvo.png',title:'Panels',link:"product/woodwork",queryparams:{subCat:204,page:1,category:333}},
      {id:3,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Boards_dybvod.png',title:'Boards',link:"/product/woodwork",queryparams:{subCat:23,page:1,category:300}},
      {id:4,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Floor_tiles_r0buux.png',title:'Floor Tiles',link:"product/tiles-flooring",queryparams:{subCat:1,page:1}},
      {id:5,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Glass_Panels_yldq4x.png',title:'Glass Panels',link:"product/panels-louvers",queryparams:{subCat:204,page:1,category:338}},
      {id:6,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Laminates_t5fjap.png',title:' Laminates',link:"product/panels-louvers",queryparams:{subCat:25,page:1}},
      {id:7,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Banding_Tape_hdwsfz.png',title:'Banding Tape',link:"/product/woodwork",queryparams:{subCat:208,page:1,}},
      {id:8,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Louvers_xujpy9.png',title:' Louvers ',link:"product/panels-louvers",queryparams:{subCat:205,page:1}},
      {id:9,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Plyboards_hhwagc.png',title:'Plyboards',link:"/product/woodwork",queryparams:{subCat:175,page:1}},
      {id:10,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Wall_Tiles_rk0thi.png',title:'Wall Tiles',link:"product/tiles-flooring",queryparams:{subCat:61,page:1}},
      {id:11,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/Blinds_ic8wyh.png',title:'Blinds',link:"product/furnishing",queryparams:{subCat:203,page:1}},
     
    ];
    this.Individual_brand=[
      {id:1,brand:'Franke',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/7_f4elmb.png',title:'Premium Kitchen Sinks',sub_title:'Efficient, durable & stylish products',link:"./brand/Franke",},
      {id:2,imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/haier_ccf28z.webp',title:'',sub_title:'',altText:'Would No.1 Brand inMajor appliances haier',link:"./brand/haier",},
      {id:3,brand:'Nippon Paint',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/2_ffltn3.png',title:'Bringing Color to Life',sub_title:'Vibrant, durable, premium-quality paints.',link:"./brand/nippon",},
      {id:4,brand:'RAK',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/14_lo2bte.png',title:'Smart Home Appliances',sub_title:'Stylish, Efficient, innovative, user-friendly solutions',link:"./brand/hafele-india-hardware",},
      {id:5,brand:'HAFELE',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/11_xzplax.png',title:'Advanced Lighting Solutions',sub_title:'Sleek and modern lighting for homes',link:"./brand/philips",},
      {id:6,brand:'Philips',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/12_l6jfr6.png',title:'Modernize Your Home with Cera',sub_title:'Efficient, stylish, hygienic solutions',link:"./brand/cera",},
      {id:7,brand:'',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/1_j4vgio.png',title:'Redefine Your Bathroom Elegance',sub_title:'Stylish, durable, innovative bath fittings.',link:"./brand/hagar",},
      {id:8,brand:'',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/4_qq7k3u.png',title:'Switch On to Elegance',sub_title:'Sleek, durable, high-performance switches.',link:"./brand/million",},
      {id:9,brand:'',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/5_uuaz2z.png',title:'Cool Comfort, Stylish Design',sub_title:'Sleek, silent, and powerful fans for your spaces.',link:"/brand/atomberg",},
      {id:10,brand:'',imgurl:'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/homepage/3_zf5ji2.png',title:'Enhance Everyday Living',sub_title:'Efficient, stylish, innovative home appliances.',link:"./brand/faber",},
  
    ]
    this.productSampUrl= "product/woodwork";
    this.productSampQueryParm= {subCat:175,page:1,isSamplechecked:true}
  }
  const baseHero = {
    id: 3,
    title: "Sampling. Sourcing. Simplified.",
    sub_title: "Leading brands. Free sample delivery for designers & architects. Dedicated material concierge service.",
    altText: "Search,Expoloar,Experience,Materials at your place",
    _homeservice: true,
  };
   if(_as.isOnMobilePlatform){
    const { imgUrl, srcset, lqipUrl} = this.optimizeImageUrl("https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Untitled_design_5_wdovs4.webp");
    this.hero_banner_list = [{ ...baseHero, imgUrl, srcset, lqipUrl }];
    }else{
      const { imgUrl, srcset, lqipUrl } = this.optimizeImageUrl("https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Homepage_kth50y.webp");
      this.hero_banner_list = [{ ...baseHero, imgUrl, srcset, lqipUrl }];
    }
    if (this.isServer && this.hero_banner_list.length > 0) {
      this.meta.addTag({
        rel: "preload",
        as: "image",
        href: this.hero_banner_list[0].imgUrl,
        fetchpriority: "high",
      });
    }
}
ngOnInit(): void {
  this.rating_service.displayRating = false;
  // this._ds.getAllDepartments();
  this.isBrowser = isPlatformBrowser(this.platformId);
  // if(this.isBrowser){
  this._actRouter.queryParams.subscribe((pra: any) => {
    this.sId = pra.secId;
    this.isUrlDisplayBudget = pra.isDisplayBudget;
  });
    

  if (this.isBrowser) {
    this._is_hero_list = true;
    setTimeout(() => {this.getmostsearchproducts(false);
  this.getInfoForm();
  if (this.isUrlDisplayBudget) {
    setTimeout(() => {
     
      this.getHomeType()
      
    }, 1000);
  }
  
 
  if (this._as.isUserLoggedIn && !this._project.selectedProject) {
    this._project.getProjectList(false)
  }
  if (this.getBudgetStatus() || this._as.user_info?.projectInfo) {
    this.getwork()
  }else{
    this._homeservice.activeBudgetSec="first-step";
  }
 
  this._abpopupinfo.getdata();
  this.setSeoData();
    const stepsource = interval(3000);
    this.stepSubscription = stepsource.subscribe(() => this.openstep());  
    if(this._as.isUserLoggedIn){
      this.getRecentlyViewedProducts();
    } }, 0);
    this.state1 = this.cachingService.getCache('appv3State') || {};
this.showButtonWithDelay()

// Add preload tag for the first image on the client (fallback)
if (this.hero_banner_list.length > 0) {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = this.hero_banner_list[0].imgUrl;
  link.setAttribute("fetchpriority", "high");
  document.head.appendChild(link);
}
}
this.setupSeoMonitoring();
this.setupLazyLoading();
this.addStructuredData();
this.preloadCriticalResources();
}
// Helper method to optimize image URLs
optimizeImageUrl(url: string): { imgUrl: string; srcset: string; lqipUrl: string } {
  const width = this.isOnMobilePlatform ? "w_800" : "w_1600";
  const imgUrl = url.replace("/upload/", `/upload/f_auto,q_auto,${width}/`);
  const srcset = `${url.replace("/upload/", "/upload/f_auto,q_auto,w_800/")} 800w, ${url.replace("/upload/", "/upload/f_auto,q_auto,w_1600/")} 1600w`;
  const lqipUrl = url.replace("/upload/", "/upload/f_auto,q_10,w_20,e_blur:2000/");
  return { imgUrl, srcset, lqipUrl };
}
setupLazyLoading(): void {
  if (!this.isBrowser) return;

  const sections = [
    { id: 'new-lunch-product', callback: () => this.getnewlaunchedproductss() },
    { id: 'find-by-budget', callback: () => this.onProductClass(false, 'economical') },
    { id: 'brand-section', callback: () => this.getALlbrands() }
  ];

  sections.forEach(section => {
    const element = document.getElementById(section.id);
    if (element) {
      this.intersectionObserver.observe(element).subscribe(isVisible => {
        if (isVisible) {
          section.callback();
          this.intersectionObserver.unobserve(element);
        }
      });
    }
  });
}

setupSeoMonitoring(): void {
  if (this.isBrowser && 'performance' in window) {
    const perfObserver = new PerformanceObserver((entryList) => {
      const entries = entryList.getEntries();
      entries.forEach(entry => {
        if (entry.entryType === 'largest-contentful-paint') {
          console.log('LCP:', entry.startTime);
        }
      });
    });
    perfObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  }
}

 addStructuredData(): void {
  const script = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": this._as.isProduction ? "Afterbricks" : "Afterbricks (Dev)",
    "url": this._as.site_url,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${this._as.site_url}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };

  // Remove existing schema if any
  const existingSchema = document.querySelector('script[type="application/ld+json"]');
  if (existingSchema) {
    existingSchema.remove();
  }

  const scriptTag = document.createElement('script');
  scriptTag.type = 'application/ld+json';
  scriptTag.text = JSON.stringify(script);
  document.head.appendChild(scriptTag);
}

preloadCriticalResources(): void {
  if (!this.isBrowser) return;

  // Preload hero images
  this.hero_banner_list.forEach(banner => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = banner.imgUrl;
    link.setAttribute('imagesrcset', banner.imgUrl);
    link.setAttribute('imagesizes', '100vw');
    document.head.appendChild(link);
  });

  // Preload fonts
  const fontLink = document.createElement('link');
  fontLink.rel = 'preload';
  fontLink.as = 'font';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=YourFontFamily&display=swap';
  fontLink.crossOrigin = 'anonymous';
  document.head.appendChild(fontLink);
}

setSeoData() {
  const title = this.isUrlDisplayBudget
    ? 'Spend as per your budget | afterbricks.com'
    : 'Architectural and interior product platform | afterbricks.com';

  const description = this.isUrlDisplayBudget
    ? "Let us help you to renovate within your pocket"
    : "Afterbricks helps professionals like interior designers, architects & contractors to explore & research latest interior finishing & fitting products from trending & creditable brands for their projects & also enable them collaborate within the connected ecosystem.";

  const image = this.isUrlDisplayBudget
    ? this._as.site_url + '/assets/images/home/budgeting-meta-image.webp'
    : 'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/Hero_Banner_in6vo7.webp';

  // Standard meta tags
  this.title.setTitle(title);
  this.meta.updateTag({ name: 'description', content: description });

  // Open Graph / Facebook
  this.meta.updateTag({ property: 'og:type', content: 'website' });
  this.meta.updateTag({ property: 'og:title', content: title });
  this.meta.updateTag({ property: 'og:description', content: description });
  this.meta.updateTag({ property: 'og:image', content: image });
  this.meta.updateTag({ property: 'og:url', content: this._as.site_url + this._router.url });
  this.meta.updateTag({ property: 'og:site_name', content: 'Afterbricks' });
  this.meta.updateTag({ property: 'og:locale', content: 'en_US' });

  // Twitter
  this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
  this.meta.updateTag({ name: 'twitter:title', content: title });
  this.meta.updateTag({ name: 'twitter:description', content: description });
  this.meta.updateTag({ name: 'twitter:image', content: image });

  // Canonical URL
  const existingCanonical = document.querySelector('link[rel="canonical"]');
  if (!existingCanonical) {
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = this._as.site_url + this._router.url;
    document.head.appendChild(link);
  }

  // Other important tags
  this.meta.addTags([
    { name: 'robots', content: 'index, follow' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { charset: 'UTF-8' },
    { name: 'theme-color', content: '#ffffff' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
    { name: 'application-name', content: 'Afterbricks - Architectural and interior product platform' }
  ]);

  if (isPlatformServer(this.platformId)) {
    this.meta.addTag({ name: 'og:image:width', content: '1200' });
    this.meta.addTag({ name: 'og:image:height', content: '630' });
  }

  this.meta.addTags([
    { name: 'robots', content: 'index, follow' },
    { charset: 'UTF-8' },
  ]);
}



toggleDirection() {
  this.direction = this.direction === '100' ? '-100' : '100';
}
ngAfterViewInit(): void{
  if(isPlatformBrowser(this.platformId)){
    this.cdref.detectChanges();
    const pageUp1Element = document.getElementById('page-up1');
    const pageUp2Element = document.getElementById('page-up2');
    pageUp1Element?.addEventListener('mouseover', this.scrollToTop.bind(this));
    pageUp2Element?.addEventListener('mouseover', this.scrollToTop.bind(this));
    this.onScroll();

    const videoElement = this.video.nativeElement;
    videoElement.muted = true; // Ensure it's muted
    videoElement.play().catch(error => console.error('Autoplay failed:', error));
  }
  setTimeout(() => {
    document.dispatchEvent(new Event('owl.refresh'));
  }, 1000);
}
scrollToTop() {
  this.ViewportScroller.scrollToPosition([0, 0]);
}

onLetsStart(){
  this._homeservice.activeBudgetSec='slHType';
}

handleBodyClick = (event: any) => {
  if (isPlatformBrowser(this.platformId)) {
  const mainOptionsContainer = document.getElementById('core-pop-container');
  const target = event.target;
  if (!mainOptionsContainer?.contains(target)) {
    // click outside the pop for close 
    if (!this.isOnMobilePlatform) {
      this.active_option = undefined;
    }
  }
}
}
ngOnDestroy() {
  if (isPlatformBrowser(this.platformId)) {
  document.body.removeEventListener('click', this.handleBodyClick);
  this.cachingService.setCache('appv3State', this.state1);
}
}


onNewLaunchesClick(){
  if (isPlatformBrowser(this.platformId)) {
  const element = document.getElementById("new-lunch-product");
  element?.scrollIntoView();
  ({ behavior: 'auto',block: 'start' });  
}
}
onFindByBudgetClick(){
  if (isPlatformBrowser(this.platformId)) {
  const element = document.getElementById("find-by-budget");
  element?.scrollIntoView();  
  ({behavior: 'auto',block: 'start' });
  
}
}
showbutton(){
  if(this.showButton){
    this.showButton = false
  }else{
    this.showButton = true
  }
  
}
@HostListener('window:scroll')
onScroll() {
  const scrollOffset = this.elementRef.nativeElement.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollOffset > 100) {
    this.is_pageup_button = true;
  } else {
    this.is_pageup_button = false;
  }
}

showButtonWithDelay(): void {
  setTimeout(() => {
    this.showButton = true;
    this.animationState++;
  }, 4000); 
}
onBudget(){
  this.getHomeType();
  this._as.isDisplayBudget = true;
  this._router.navigate(
    [],
    {
      relativeTo: this._actRouter,
      queryParams: { isDisplayBudget: true,},
      queryParamsHandling: 'merge',
      replaceUrl:true
    });
  this.setSeoData();
}
closecorepopup(){
  if(!this._as.isOnMobilePlatform){
    this.isCoreOption=false;
    this.activeCoreSubCategory = undefined;
    this.active_option= undefined;
  }
  
}
onCoreOptions(key: any) {
  this.active_categorys = [];
  this.dealer_citys = [];
 
  if (this.active_option == key) {
    this.active_option = undefined;
    return;
  }
  for (const mc of this._ds.departments_list) {
    if (key == "manufacturer" && mc.is_oem) {
      this.active_categorys.push(mc);
    }
    if (key == "dealer" && mc.is_dealer) {
      if (!this.dealer_citys.length) {
        this.dealer_citys = mc.dealer_citys;
      }
      this.active_categorys.push(mc);
    }
    if (key == "product") {
      this.active_categorys.push(mc);
    
      // this.mainCategoryoption(0)
    }
  }
 
  if (this._as.isOnMobilePlatform) {
    this.visibleSidebarCore = true;
  }else{
    this.isCoreOption = true;
    setTimeout(() => {
      this.mainCategoryoption(0);
  }, 500);
  }
  this.active_option = key;
  // this.mainCategoryoption(0);
  if (key == "professional") {
    this.getProfessional();
  }
  this.activeCoreSubCategory = false;
  this.activermainoptionsindex = undefined;
  this.activeprofTypeindex = undefined;
  this.active_pros_option="";
  this.onActivate()
}
getProfessional() {
  this.is_load_type = true;
  const url = this._as.api_base_url + "home/pro-type/";
  this._as.getRequest(url, true).subscribe(
    (res: any) => {
      this.pro_types = res.profession_type_list;
      this.is_load_type = false;
    },
    (err: any) => {
      if (err) {
        this.is_load_type = false;
      }
    }
  );
}
onSampleOrders(){
  this.router.navigate(['sample-order']);
  // this.instantshow();
}
onActivate() {
  if (isPlatformBrowser(this.platformId)) {
  const mainOptionsContainer = document.getElementById('main-options-container');
  if (mainOptionsContainer) {
    const offsetTop = this.getOffsetTop(mainOptionsContainer) - 130;
    this.ViewportScroller.scrollToPosition([0, offsetTop]);
  }
}
}
private getOffsetTop(element: HTMLElement): number {
  let offsetTop = element.offsetTop;
  let offsetParent = element.offsetParent as HTMLElement;
  while (offsetParent) {
    offsetTop += offsetParent.offsetTop;
    offsetParent = offsetParent.offsetParent as HTMLElement;
  }
  return offsetTop;
}
getOptionHeading():any{
  if(this.active_option=='product'){
    return 'Products';
  }else if(this.active_option=='manufacturer'){
    return 'Brands'
  }else if(this.active_option=='dealer'){
    return 'Showrooms'
  }else if(this.active_option == 'professional'){
    return "Professional"
  }
}
getIcon(){
  if(this.active_option=='product'){
    return 'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/Vector_2_np4o7y.svg';
  }else if(this.active_option=='manufacturer'){
    return 'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/Vector_1_eqkhd8.svg'
  }else if(this.active_option=='dealer'){
    return 'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/Group_nb3zbz.svg'
  }else if(this.active_option=='professional'){
    return 'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/Group_1_atpp9x.svg'
  }else{
    return 'https://s3-afterbricks.s3.ap-south-1.amazonaws.com/assets/icons/Vector_2_np4o7y.svg'
  }
}
onProfessionalOptions() {
  if(this._as.isOnMobilePlatform){
    this._router.navigate(['service-provider'])
  }else{
    this.active_option=undefined;
    this.proClickCount+=1;
    if(this.proClickCount % 2 === 1){
    this.active_pros_option = 'professional';
    this.getProfessional();
    }else{
      this.active_pros_option = '';
    }
   this.active_option = 'professional';
   this.isCoreOption = true;
   setTimeout(() => {
   this.onProfessional(this.pro_types[0], 0)
   },500)
  }
}
mainCategoryoption(mci: any) {
  this.activermainoptionsindex = mci;
   if (this.active_option == "dealer") {
    this.dealer_citys = this.active_categorys[mci].dealer_citys;
  } else if (this.active_option == "manufacturer") {
    this.getBrands(this.active_categorys[mci].id);
  } else {
    this.active_categorys = this._ds.departments_list;
  }
  this.activeCoreSubCategory = true;
  this.page_date_load =true;
}
getBrands(id: any) {
  const url = this._as.api_base_url + "staff/bwl/?pk=" + id;
  this._as.getRequest(url, true).subscribe(
    (res: any) => {
      this.global_loader = false;
      this.category_brand_list = res.brand_list;
      this.category_brand_load = true;
    },
    (err: any) => {
      if (err) {
        this.global_loader = false;
      }
    }
  );
}
onBackSlider() {
  if (this.activeCoreSubCategory) {
    this.activeCoreSubCategory = false;
    return
  }
  this.active_option = undefined;
  this.activeCoreSubCategory = false;
  this.visibleSidebarCore = false;
}

onProduct(subId: any) {
  this._router.navigate(
    [
      "product/" +
      this._ds.departments_list[this.activermainoptionsindex].slug +
      "/",
    ],
    { queryParams: { subCat: subId } }
  );

}
onProfessional(prof: any, pi: number) {
  this.isProCityLoading = true;
  this.selected_Type = prof;
  this.activeCoreSubCategory = true;
  this.activeprofTypeindex = pi;
  const url =
    this._as.api_base_url +
    "home/pro-cities/?id=" +
    this.pro_types[this.activeprofTypeindex].id;
  this._as.getRequest(url, true).subscribe(
    (res: any) => {
      this.prof_locations = res.profession_locations_list;
      if (!this.prof_locations.length) {
        this.category_prof_brand_load = false;
      } else {
        this.category_prof_brand_load = true;
      }
      this.isProCityLoading = false;
      this.ViewportScroller.scrollToPosition([0,50])
    },
    (err: any) => {
      if (err) {
        this.isProCityLoading = false;
      }
    }
  );
}
onSelectCity(city: any) {
  this._router.navigate([`service-provider/`],{queryParams: { type: this.selected_Type.id, city: city.id } });
}
onHideCoreBox() {
  this.proClickCount=0
  this.active_pros_option = "";
}

getmostsearchproducts(key?: boolean) {
  this.newproPage = 1 + this.newproPage;
  let url: string;
  if (this.activeMostCatId) {
    url = this._as.api_base_url + "home/most-view-home-prod/?main_category_id=" + this.activeMostCatId;
  } else {
    url = this._as.api_base_url + "home/most-view-home-prod/?page="+this.newproPage;
  }
  this._as.getRequest(url, true).subscribe((res: any) => {
    if (res) {

      res.forEach((p:any)=>{
        this.mostsearchproducts.push(p)
      })
      this.is_more_product_loader = false;
    }
  },
    (err: any) => {
      if (err) {
        this.is_more_product_loader = false;
      }
    })
    if (!key) {
      this.getnewlaunchedproductss();
    }
    // this.onProductClass(false,'Economical')
}
ctr(form_type: any, id: number) {
  this.active_budget_index = undefined;
  const url = this._as.api_base_url + 'home/card-click-count/';
  const data = {
    form_type: form_type,
    uuid: JSON.parse(this.localStorageService.getItem('uuid') || '' ),
    id: id
  }
  this._as.postRequest(url, data, true).subscribe((res: any) => {
    if (res) {
console.log(res)
    }
  })
}

onProductClassCategpry(mcid: number) {
  this.showAllProducts=false;
  this.activeClassCatId = mcid;
  if (this.is_luxury_product) {
    this.getproductClass(true, 'luxury')
  }
  else if (this.is_premium_product) {
    this.getproductClass(true, 'premium')
  }
  else if (this.is_standard_choice) {
    this.getproductClass(true, 'standard')
  }
  else if (this.is_most_economical) {
   
    this.getproductClass(true, 'economical')
  } else {
  
    this.getproductClass(true,'economical')
  }

}
onProductClass(flag:boolean,key: string) {
  if (key == 'luxury') {
    this.is_luxury_product = true;
    this.is_premium_product = false;
    this.is_standard_choice = false;
    this.is_most_economical = false;
  } else if (key == 'premium') {
    this.is_premium_product = true;
    this.is_standard_choice = false;
    this.is_most_economical = false;
    this.is_luxury_product = false;
  } else if (key == 'standard') {
    this.is_standard_choice = true;
    this.is_most_economical = false;
    this.is_premium_product = false;
    this.is_luxury_product = false;
  } else {
    this.is_most_economical = true;
    this.is_standard_choice = false;
    this.is_premium_product = false;
    this.is_luxury_product = false;
  }
  this.active_budget_index = undefined;
  this.getproductClass(flag, key)
}

getproductClass(flag: boolean, key?: any) {
  let url: string;
  if (this.activeClassCatId) {
    url = this._as.api_base_url + "home/product-class-home-prod/?main_category_id=" + this.activeClassCatId + '&product_class=' + key+"&page=1";
  } else {
    url = this._as.api_base_url + "home/product-class-home-prod/?product_class=" + key+"&page=1";
  }
 console.log(key)
  this._as.getRequest(url, true).subscribe((res: any) => {
    if (res) {
      this.class_wise_products = res.products_class;
      this.departments_list = res.main_category_list;
      this.is_product_class_loader = false;
        for(let i=0;i < this.class_wise_products.length ;i++){
          const ci=i%this.background_color.length;
          this.class_wise_products[i].bgColor = this.background_color[ci];
          if(this.class_wise_products[i].product_type_list.length){
            this.class_wise_products[i].slice_product_type_list = this.class_wise_products[i].product_type_list.slice(0, 2)
          }
          
        }
        // this.onProductClassCategpry(this.departments_list[0].id)
    }
  },
    (err: any) => {
      if (err) {
        this.is_product_class_loader = false;
      }
    })
    if (!flag) {
      // this.getProfessionalList();
    }
    this.getALlbrands()
}
showMoreTypes(ci:any,flag:any){

  // if(flag){
  //   this.is_showmore=flag;
  //   this.class_wise_products[ci].slice_product_type_list = this.class_wise_products[ci].product_type_list;
    this.active_budget_index = ci;
  // }else{
   
  // }
  if(flag){
  for(let i=0;i < this.class_wise_products.length;i++){
    if(ci==i){
      this.class_wise_products[i].slice_product_type_list = this.class_wise_products[i].product_type_list;
      this.active_budget_index = ci;
    }else{
      this.class_wise_products[i].slice_product_type_list = this.class_wise_products[i].product_type_list.slice(0, 2);
    }
  }
}else{
    this.is_showmore=flag;
    this.class_wise_products[ci].slice_product_type_list = this.class_wise_products[ci].product_type_list.slice(0, 2);
    this.active_budget_index =undefined;
  }
  
}
onSmartView(){
  if(this._router.url.split('/')[1].split('?')[0] == "smart-search"){
    return true
  }else{
    return false
  }
}

getALlbrands() {
  const url = this._as.api_base_url + "product/brandlist/";
  this._as.getRequest(url, true).subscribe(
    (res: any) => {
      this.brand_list = res.data;
      this.is_brand_loader = false;
      this.total_brand=res.brand_count;
      this.onMainCategory()
    },(err:any)=>{
      if(err){
        this.is_brand_loader = false;
      }
    }
  );
}
onBrandRegistration(){
  this._router.navigate(['oem/form-first'])
}

onMainCategory(id?: number) {
  this.activemaincategoryDealer = id;
  this.getDealerList(true);
}
getDealerList(flag: boolean) {
  let url: string;
  if (this.activemaincategoryDealer) {
    url = this._as.api_base_url + 'home/dealers/?id=' + this.activemaincategoryDealer;
  } else {
    url = this._as.api_base_url + 'home/dealers/';
  }
  this._as.getRequest(url, true).subscribe((res: any) => {
    if (res) {
      this.top_dealers = [];
      this.top_dealers = res.dealers;
      this.is_dealers_loader = false;
      if (!flag) {
        // this.createPopularLink();
      }

    }
  },
    (err: any) => {
      if (err) {
        this.is_dealers_loader = false;
      }
    })
    this.getProfessionalList();
}
// Budget
getStep(){
  if(this._homeservice.activeBudgetSec=='slSpace'){
    return 2
  }else if(this._homeservice.activeBudgetSec=='slArea'){
    return 3
  }else if(this._homeservice.activeBudgetSec=='slCity'){
    return 4
  }else{
    return 1
  }
}
getBudgetStatus() {
  try {
    let gustBudget:any;
    try{
      gustBudget = JSON.parse(this.localStorageService.getItem('gustBudget')|| '');
    }catch{
      gustBudget = undefined
    }
     
    
    if (gustBudget && gustBudget.gustBudget.is_budget) {
      this.budgetBtnText = 'See Budget';
      this.budgetTitle = 'Check your budget';
      return true;
    } else {
      return false;
    }
  } catch (e) {
    let ishouseSpace:any;
    try {
       ishouseSpace = JSON.parse(this.localStorageService.getItem('ishouseSpace') || '');
    }catch{
       ishouseSpace = '';
    }
     ishouseSpace = JSON.parse(this.localStorageService.getItem('ishouseSpace') || '');
    console.log("ishouseSpace",ishouseSpace)
    if (ishouseSpace) {
      this.budgetBtnText = 'Continue';
      this.budgetTitle = 'Complete your steps';
      return true;
    }
    return false;
  }
}
getHomeType() {
  const url = this._as.api_base_url + 'space/hometype/';
  this._as.getRequest(url, true)
    .subscribe((res: any) => {
      for (const ht of res.data) {
        this.hometypes.push({ name: ht.name, id: ht.id, icon: ht.icon, autoplayTimeout: 1000, icon_mobile: ht.icon_mobile });
      }
      if(this.isUrlDisplayBudget){
        this._as.isDisplayBudget = true;
      }
      this.pageLoad = true;
      this.getCitysForBudget();
    });
}
getCitysForBudget() {
  const url = this._as.api_base_url + 'home/get-city/';
  this._as.getRequest(url, true)
    .subscribe((res: any) => {
      this.citys = res.data;
      this.pageLoad = true;
      // this.getReturnsExchange()
      if (this._project.selectedProject && Object.keys(this._project.selectedProject)?.length) {
        this.getSlpBrands();
        this._project.getInfoData();
      }
    });
}
getInfoForm() {
  this.infoForm = this._fb.group({
    'area': [null, [Validators.required, Validators.pattern('^[0-9,.]+$'), Validators.min(this.minval), Validators.max(this.maxval)]],
    'home_type': ['', [Validators.required]],
    'area_unit': ['ft']
  });
}

valueChange(hm: any) {
  if (hm.id == 1) {
    this.minval = 200;
    this.maxval = 500;
  } else if (hm.id == 2) {
    this.minval = 450;
    this.maxval = 1500;


  } else if (hm.id == 3) {
    this.minval = 700;
    this.maxval = 3000;

  } else if (hm.id == 4) {
    this.minval = 1200;
    this.maxval = 3500;

  } else if (hm.id == 5) {
    this.minval = 1400;
    this.maxval = 5000;

  } else if (hm.id == 6) {
    this.minval = 1600;
    this.maxval = 7000;

  }
  else if (hm.id == 7) {
    this.minval = 2000;
    this.maxval = 10000;
  }
  else {
    this.minval = 100;
    this.maxval = 15000;
  }
  this.getInfoForm();
  if(hm){
    this.infoForm?.get('home_type')?.setValue(hm);
  }
  
  this._homeservice.activeBudgetSec = 'slArea';
  this._homeservice.counter++;
}

onSubmitinfo() {
  this.submitted = true;
  this.isAreaNull = false;
  if (this.infoForm?.invalid) {
    this.isAreaNull = true;
    return;
  } else {
    this.inline_loader = true;
    this._homeservice.getStart(this.infoForm?.value);
  }
}
get info() {
  return this.infoForm?.controls ?? {};
}
onSelectBudgetCity(index: any) {
  this.activeCityi = index;
  let gustProjectData:any;
  try{
    gustProjectData = JSON.parse(this.localStorageService.getItem('gustProjectData') || '');
  }catch{
    gustProjectData = null;
  }

  gustProjectData.city = this.citys[this.activeCityi].id;
  this.localStorageService.setItem('gustProjectData', JSON.stringify(gustProjectData))
  const _usCity = {
    city: this.citys[this.activeCityi].id,
    cindex: index

  }
  this.project_loader = true;
  this.localStorageService.setItem('_usCity', JSON.stringify(_usCity));
  this._homeservice.counter--;
  this.onfinal();
}
  onfinal() {
    let info_data:any;
    try{
      info_data = JSON.parse(this.localStorageService.getItem('gustProjectData') || '');
    }catch{
      info_data = undefined;
    }
    
    this.localStorageService.setItem('info_data', JSON.stringify({ info_data }));
    const url = this._as.api_base_url + 'space/getStart/';
    const data = {
      info_data: info_data,
      renovation_type: 'complete',
      min_area: this.minval
    };
    // info_data
    this.is_budget_cal_loader = true;
    this._as.postRequest(url, data, true)
      .subscribe((res: any) => {
        const project_id = res.project;
        this.localStorageService.setItem('project', JSON.stringify({ project_id }));
        if(this._router.url.includes('isDisplayBudget')){
          
          this._abpopupinfo.onSaveUserActivity();
          this.localStorageService.setItem('isinfopopupviewed', JSON.stringify(true));
        }
        if (this._as.isUserLoggedIn) {
          this._as.user_info.projectInfo = {
            id: project_id,
            area: data.info_data.area,
            budget: data.info_data.budget,
            step: 1,
            is_active: true,
            isStepsComplated: false
          };
          const user_info = JSON.parse(this.localStorageService.getItem('user_info')|| '');
          user_info.isnew = true;
          this._as.user_info.isnew = true;
          user_info.projectInfo = this._as.user_info.projectInfo;
          this.localStorageService.setItem('user_info', JSON.stringify(user_info));
        } else {
          this.localStorageService.setItem('ishouseSpace', JSON.stringify({ ishouseSpace: true }));
        }
        this._as.isDisplayBudget = false;
        this.localStorageService.removeItem('_blid');
        this.localStorageService.removeItem('_uht');
        this.localStorageService.removeItem('_usCity');
        this.localStorageService.removeItem('info_data');
        this.localStorageService.removeItem('_uStep2');
        this.localStorageService.removeItem('_uStep1');
        this.localStorageService.removeItem('activeBudgetSec');
        this._router.navigate([`budget-calc/space`], { queryParams: { pId: project_id } });
        setTimeout(() => {
          this._homeservice.activeBudgetSec = 'slHType';
        }, 2000);
        this.inline_loader = false;
        this.project_loader = false;
        this.is_budget_cal_loader = false;
        this.setSeoData();
      },
        (err: any) => {
          if (err) {
            this.inline_loader = false;
            this.project_loader = false;
            this.is_budget_cal_loader = false;
          }
        });
  }
  
getSlpBrands() {
  const form_type = 'save-idea';
  const url = this._as.api_base_url + 'user/collection-data/?project=' + this._project.selectedProject.id + '&form_type=' + form_type;
  this._as.getRequest(url, true).subscribe((res: any) => {
    if (res) {
      this.saveidea_brands = res.brand_list;
    }
  })
}

getwork() {
  this.global_loader = true;
  console.log( this._as.user_info)
  if (this._as.user_info?.projectInfo) {
    this.project_id = this._as.user_info.projectInfo.id;
  } else {
    this.project_id = JSON.parse(this.localStorageService.getItem('project')|| '')?.project_id;
  }
  if(this.project_id){
    this.isAssignedBudget = true;
    const url = this._as.api_base_url + 'workitem/v1getBudget/?project=' + this.project_id;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.work_list = res.workitem_budget;
        this.totalBudget = res.budget;
        setTimeout(() => {
          this.global_loader = false;
        }, 500);

      },
        (err: any) => {
          if (err) {
            this.global_loader = false;
          }
        });
  }else{
    console.log("else")
  }
  

}

onSelectWork(index: any) {
  if (!this._as.isUserLoggedIn) {
    this.budgetContinue();
  }
  else {
    this._router.navigate(["/budget-calc/work"], {
      queryParams: { pId: this.project_id, index: index },
    });
  }
}

budgetContinue() {
  try {
    this.project_id = this._as.user_info.projectInfo.id;
    if (!this.localStorageService.getItem('mobile')) {
      this._router.navigate(["/budget-calc/work"], {
        queryParams: { pId: this.project_id, displayMobile: true },
      });
    }
    else {
      this._router.navigate(["/budget-calc/work"], {
        queryParams: { pId: this.project_id },
      });
    }
  } catch {
    try {
      const gustBudget = JSON.parse(this.localStorageService.getItem('gustBudget') || '');
      this.project_id = gustBudget.gustBudget.project_id;
      if (gustBudget.gustBudget.is_budget) {
        this._router.navigate(["/budget-calc/work"], {
          queryParams: { pId: this.project_id },
        });
      }
      if (!this.localStorageService.getItem('mobile')) {
        this._router.navigate(["/budget-calc/work"], {
          queryParams: { pId: this.project_id, displayMobile: true },
        });
      }
    } catch {
      const project_id = JSON.parse(this.localStorageService.getItem('project')|| '').project_id;
      this._router.navigate(["/budget-calc/space"], {
        queryParams: { pId: project_id },
      });
    }

  }
}
joinaspro() {
  const returnUrl = this._as.subscribeUrl;
  const win = this.window.nativeWindow;
  if(win){
      win.location.href = returnUrl;
  }
}

getProfessionalList() {
  const url = this._as.api_base_url + 'home/professional/';
  this._as.getRequest(url, true)
    .subscribe((res: any) => {
      this.profession_list = res.profession_list;
      this.is_professionloader = false;
      if (this.isOnMobilePlatform) {
        this.displayedProfession_list = this.profession_list.slice(0, 6);
      }
      else {
        this.displayedProfession_list = this.profession_list.slice(0, 9);
      }
      // this.createPopularLink();
    
    });
}
  createPopularLink() {
    throw new Error('Method not implemented.');
  }

  getnewlaunchedproductss() {
    const url = this._as.api_base_url + "home/new-launched-home-prod/";
    this._as.getRequest(url, true).subscribe((res: any) => {
      if (res) {
        this.newlaunchedproducts = res.new_launched_products;
        this.is_new_launched_loader = false;
        
      }
    },
      (err: any) => {
        if (err) {
          this.is_new_launched_loader = false;
        }
      })
      this.onProductClass(false,'economical')
  }
  openstep() {
    if (this.activeStepindex === this.howitworksptes.length - 1) {
      this.activeStepindex = 0;
    } else {
      this.activeStepindex = 1 + this.activeStepindex;
    }
  }
  getqueryParams(populerProd:any,pt?:any){
    let query:Params;
   
  if(populerProd.product_class=='premium'){
    query = {
      subCat:populerProd.sub_category_id,
      category:pt?.id,is_premium_product:true
    }
  }else if(populerProd.product_class=='standard'){
    query = {
      subCat:populerProd.sub_category_id,
      category:pt?.id,is_standard_choice:true
    }
  }else{
    query = {
      subCat:populerProd.sub_category_id,
      category:pt?.id,is_most_economical:true
    }
  }
  return query;
  }
  closeBudgetPopup(){
    this._as.isDisplayBudget=false;
  this._router.navigate(
    [],
    {
      relativeTo: this._actRouter,
      queryParams: { isDisplayBudget: null,},
      replaceUrl:true
    });
  this.setSeoData()
  }
  getproductpagequeryParams(key:any){
    let query:Params;
    if(key=='smart-locks'){
      query = {
        subCat:120,
        category:236
      }
      return query
    }else if(key=='hinges'){
      query = {
        subCat:30,
        category:213
      }
      return query
    }else{
      return {}
    }
  }

  getRecentlyViewedProducts() {
    const url = this._as.api_base_url + "product/recently-viewed/?slug_name=" + this.slug_name;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.recentlyViewedProducts = res.products;
        this.global_loader = false;
        // this.updatedRecentlyViewedProducts()
      });
  }
  ProductCategoriesByBudget(){
    this.showAllProducts = !this.showAllProducts;
  }

  mbscrollup() {
    setTimeout(() => {
      this.ViewportScroller.scrollToPosition([0, 0]);
    }, 1000);
  }
}
